export const LABELS_INIT_SUCCESS = 'LABELS_INIT_SUCCESS';
export const INIT = 'INIT';
export const INIT_FAIL = 'INIT_FAIL';
export const INIT_SUCCESS = 'INIT_SUCCESS';
export const SELECT_ROOM_GROUP = 'SELECT_ROOM_GROUP';
export const GET_PRICE_MATRIX_FLIGHT_TIME_SUCCESS = 'GET_PRICE_MATRIX_FLIGHT_TIME_SUCCESS';
export const ADD_TO_CART_SUCCESS = 'ADD_TO_CART_SUCCESS';
export const ADD_TO_CART_FAIL = 'ADD_TO_CART_FAIL';
export const ADD_TO_CART_INIT = 'ADD_TO_CART_INIT';
export const TOGGLE_ERROR_POPUP = 'TOGGLE_ERROR_POPUP';
